// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2":"9367fa4075bd45cda351","348":"6b06e2438c2b42fc322b","495":"46da5042748d76075ebc"}[chunkId] + ".js";
};